var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"headerCom"},[_c('img',{staticClass:"back",attrs:{"src":"/images/public/back.png"},on:{"click":_vm.goBack}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }